import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ArrowRightCircle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ArrowRightCircle.Outline {...props} />
  ) : (
    <ArrowRightCircle.Solid {...props} />
  );
}

ArrowRightCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M10.0284 14.9397C9.73491 15.232 9.73388 15.7069 10.0261 16.0004C10.3184 16.2939 10.7933 16.2949 11.0868 16.0027L14.5728 12.5317C14.7142 12.3909 14.7936 12.1997 14.7936 12.0002C14.7936 11.8007 14.7142 11.6095 14.5728 11.4687L11.0868 7.99772C10.7933 7.70546 10.3184 7.70648 10.0261 8.00001C9.73388 8.29353 9.73491 8.7684 10.0284 9.06066L12.9807 12.0002L10.0284 14.9397Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 17.5233 6.47784 22 12 22C17.5222 22 22 17.5233 22 12C22 6.47779 17.5222 2 12 2C6.47779 2 2 6.47779 2 12ZM12 20.5C7.30616 20.5 3.5 16.6947 3.5 12C3.5 7.30621 7.30621 3.5 12 3.5C16.6938 3.5 20.5 7.30621 20.5 12C20.5 16.6947 16.6938 20.5 12 20.5Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ArrowRightCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
